import React, { useEffect } from 'react';
import NavBar from '../components/navigation/NavBar';
import style from '../css/Course.module.css';
import { Link } from 'react-router-dom';
import CourseInfo from '../components/common/CourseInfo';
import { CourseData } from '../components/common/Data';
import Footer from '../components/common/Footer';
import ComInfo from '../components/common/ComInfo';
import BottomNav from '../components/navigation/BottomNav';

function Course() {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);
	return (
		<div>
			<div className="sticky">
				<NavBar />
			</div>
			<div className={style.txtdiv}>
				<p className={style.txt}>Start learning today.</p>
				<p className={style.txt1}>KANASU EDUCATIONAL AND CHARITABLE TRUST</p>
				<p className={style.txt2}>
					offers various courses,
					<br /> browse below
				</p>
				<div className={style.row}>
					<Link className={style.btn1} to={'/Contact'}>
						Contact
					</Link>
					<Link className={style.btn2} to={'/About'}>
						Know More
					</Link>
				</div>
			</div>

			<CourseInfo coursedata={CourseData} />
			<ComInfo />
			<Footer />
			<div className="sticky_mob">
				<BottomNav />
			</div>
		</div>
	);
}

export default Course;
